
import { defineComponent, PropType } from 'vue'

// Composables
import { useConfirm } from '@/use/confirm'
import { useAlertManager, UseAlertSelection } from '@/alerting/use-alerts'

export default defineComponent({
  name: 'AlertsSelection',

  props: {
    selection: {
      type: Object as PropType<UseAlertSelection>,
      required: true,
    },
  },

  setup(props, ctx) {
    const confirm = useConfirm()
    const alertMan = useAlertManager()

    function openAlerts() {
      alertMan.open(props.selection.closedAlerts).then(() => {
        props.selection.reset()
        ctx.emit('change')
      })
    }

    function closeAlerts() {
      alertMan.close(props.selection.openAlerts).then(() => {
        props.selection.reset()
        ctx.emit('change')
      })
    }

    function deleteAlerts() {
      confirm
        .open('Delete', 'Do you really want to delete selected alerts?')
        .then(() => {
          alertMan.delete(props.selection.alerts).then(() => {
            props.selection.reset()
            ctx.emit('change')
          })
        })
        .catch(() => {})
    }

    return {
      alertMan,

      closeAlerts,
      openAlerts,
      deleteAlerts,
    }
  },
})
